export type LoginEnterType = EnterType.Email | EnterType.Messenger | EnterType.Bot;

export enum EnterType {
  Email = 'by-email',
  Messenger = 'by-messenger',
  Bot = 'bot',
}
